import { useEffect, useState } from 'react';
import { Paper, Box } from '@material-ui/core';
import { DataGrid } from '@mui/x-data-grid';
import PropTypes from 'prop-types';
import { QuickSearchToolbar } from '../rack/dashboard/RacksTable';
import DeleteVmTemplateButton from './DeleteVmTemplateButton';
import VMTemplatePreviewButton from './VMTemplatePreviewButton';

const paginationModel = { page: 0, pageSize: 5 };

VMTemplatesTable.propTypes = {
  vmTemplates: PropTypes.array,
  getVMTemplateList: PropTypes.func
};

export default function VMTemplatesTable({ vmTemplates, getVMTemplateList }) {
  const defaultPageSize = 5;
  const [pageSize, setPageSize] = useState(defaultPageSize);

  const columns = [
    { field: 'name', headerName: 'Name', flex: 1 },
    { field: 'label', headerName: 'Label', flex: 1 },
    { field: 'description', headerName: 'Description', flex: 1 },
    { field: 'architecture', headerName: 'Architecture', sortable: false, flex: 1 },
    { field: 'provisioner_identity', headerName: 'Team Name', sortable: false, flex: 1 },
    {
      field: 'actions',
      headerName: '',
      sortable: false,
      flex: 1,
      renderCell: (param) => (
        <Box sx={{ textAlign: 'right', width: '100%' }}>
          <VMTemplatePreviewButton type="icononly" variant="contained" vm={param.row} />
          <DeleteVmTemplateButton
            type="icononly"
            variant="contained"
            vmTemplate={param.row.name}
            onDeleted={getVMTemplateList}
          />
        </Box>
      )
    }
  ];

  useEffect(() => {
    getVMTemplateList();
    // eslint-disable-next-line
  }, []);

  return (
    <Paper sx={{ minHeight: 400, width: '100%' }}>
      <DataGrid
        rows={vmTemplates}
        columns={columns}
        getRowId={(row) => row.name}
        autoHeight
        initialState={{ pagination: { paginationModel } }}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[5, 10, 20]}
        pagination
        filterPanelDeleteIcon
        components={{ Toolbar: QuickSearchToolbar }}
        sx={{ border: 0 }}
      />
    </Paper>
  );
}
